import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IExtensionsWorkbenchService = ( createDecorator('extensionsWorkbenchService'));
export { IExtensionsWorkbenchService };
